/**
 * Typed fetchers for /api/v1/shares — owner-initiated sharing (ADR-0015).
 *
 * Distinct from `grants.ts`, the administrator surface. Here the authority is
 * ownership: the backend re-checks it on every call and answers "not found"
 * for a resource the caller does not own.
 */

import type { components } from "./_generated/schema";
import { apiFetch } from "./apiFetch";

export type ShareOut = components["schemas"]["ShareOut"];
export type ShareListOut = components["schemas"]["ShareListOut"];
export type CreateShareIn = components["schemas"]["CreateShareIn"];

export function listShares(
  token: string,
  resourceType: string,
  resourceId: string,
): Promise<ShareListOut> {
  const qs = new URLSearchParams({ resource_type: resourceType, resource_id: resourceId });
  return apiFetch<ShareListOut>(`/api/v1/shares?${qs.toString()}`, { token });
}

export function createShare(token: string, input: CreateShareIn): Promise<ShareOut> {
  return apiFetch<ShareOut>("/api/v1/shares", { method: "POST", token, json: input });
}

export function revokeShare(token: string, grantId: string, reason: string): Promise<void> {
  return apiFetch<void>(`/api/v1/shares/${encodeURIComponent(grantId)}`, {
    method: "DELETE",
    token,
    json: { reason },
  });
}
